<template>
  <button class="nch--blog-btn" :class="[{ small }]">
    <slot />
  </button>
</template>
<script>
export default {
  name: 'Button',
  props: {
    small: {
      type: Boolean,
    },
  },
};
</script>
<style scoped>
.nch--blog-btn {
  padding: 0.9rem;
  font-size: 1rem;
  border: none;
  background-color: var(--blog-primary);
  color: var(--blog-secondary);
  border-radius: 8px;
  z-index: 1;
}
.nch--blog-btn:hover:not([disabled]):not(.small){
  box-shadow: 2px 5px 10px rgba(0,0,0,0.3);
}
.nch--blog-btn[disabled] {
  background-color: #e2e2e2;
  color: #d2d2d2
}
.nch--blog-btn.small{
  padding: 0.1rem;
  border: none;
  background-color: #fff;
  color: var(--blog-text);
  border: 1px solid var(--blog-border);
  border-radius: 5px;
}
</style>
